import { gql } from 'apollo-angular';

const SET_OFFER_PRODUCTS_PRICES = gql`
  mutation setOfferProductPrices($input: OfferProductPricesRequest!) {
    offerProductPrices(input: $input) {
      success
    }
  }
`;

export default SET_OFFER_PRODUCTS_PRICES;
